<template>
    <div class="payment-wrapper">

        <div class="payment-header pb-0 px-3 px-lg-0">
            <div class="container">
                <h1 class="payment-title">
                    {{ $t('buy_subscription') }}: {{ subscription.subscription }}
                    <span v-if="timetable">{{ $t('to_group') }} {{timetable.name}}</span>
                </h1>

                <div class="ui-steeps">
                    <ul class="ui-steeps__header">
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                1. {{ $t('order') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-active">
                            <div class="ui-steep-header-item__text">
                                2. {{ $t('payment') }}
                            </div>
                        </li>
                        <li class="ui-steep-header-item is-disabled">
                            <div class="ui-steep-header-item__text">
                                <span class="d-none d-sm-block">3. {{ $t('payment_information') }}</span>
                                <span class="d-block d-sm-none">3. {{ $t('abput_payment') }}</span>
                            </div>
                        </li>
                    </ul>
                </div><!-- /.ui-steeps -->
            </div><!-- /.container -->
        </div>


        <div class="payment-gateway px-3 px-lg-0">
            <div class="container">
                <div class="row" v-if="error">
                    <div class="col-12">
                        <base-alert type="danger">{{error}}</base-alert>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h2 v-show="flavorConfig.payConfig.yookassa" class="payment-subtitle">
                            {{ $t('safe_payments_notice') }}
                        </h2>

                        <div class="payment-subtitle-notice">{{ $t('we_do_not_store_pay_data') }}</div>
                    </div>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-6 order-2 order-lg-1 payment-pay-widget-wrapper">
                        <div v-if="!!notification" class="text-center">
                            <span style="color: red;">
                                {{ $t('promocode_failed') }}:<br/> {{ notification }} <br/><br/>
                            </span>
                            {{ $t('promocode_failed_title') }}:
                            <div class="text-left mx-auto" style="width: 70%">
                                <ul>
                                    <li>{{ $t('promocode_failed_1') }};</li>
                                    <li>{{ $t('promocode_failed_2') }};</li>
                                    <li>{{ $t('promocode_failed_3') }}.</li>
                                </ul>
                            </div>
                        </div>

                        <p v-if="discount>0" class="text-center mb-1">
                            {{ $t('promocode_discount', { discount: discount }) }}<br/>
                            <span class="cena">{{ $t('promocode_total_price', { price: price }) }}</span>
                        </p>

                        <pay-widget
                                :item="payItem"
                                @captured="paymentCaptured"
                        />

                    </div>
                    <div class="col-12 col-lg order-1 order-lg-2 mb-lg-0 mb-3">
                        <div class="row d-flex flex-wrap align-items-center">
                            <div class="col-lg-12 col-4 text-lg-right text-center">
                                <img src="poliimg/visa-verified.png" class="img-fluid mb-lg-5">
                            </div>
                            <div v-show="!flavorConfig.payConfig.revolut" class="col-lg-12 col-4 text-lg-right text-center">
                                <img src="poliimg/mir-accept.png" class="img-fluid mb-lg-5">
                            </div>
                            <div class="col-lg-12 col-4 text-lg-right text-center">
                                <img src="poliimg/mastercard-securecode.png" class="img-fluid mb-lg-5">
                            </div>
                        </div>
                    </div>
                </div><!-- /.container -->
            </div>
        </div>

        <div class="payment-course">
            <div class="container">

                <div class="row justify-content-center mb-5">
                    <div class="col-12 col-lg-5">
                        <SubscriptionItem
                                :subscription="subscription"
                                :active="true"
                                :hideOrderButton="true"
                        />
                    </div>
                </div>
            </div><!-- /.container -->
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import PayWidget from '@/components/PayWidget.vue'
    import SubscriptionItem from "./SubscriptionItem";
    import subscriprionApi from "../../data/SubscriptionApi";
    import timetableApi from "../../data/TimetablesApi";
    import CStorage from "../../data/CStorage";

    export default {
        name: 'payment',
        props: ['id', 'timetableId'],
        components: {
            PayWidget,
            SubscriptionItem,
        },
        data() {
            return {
                subscription: {},
                loading: false,
                paySystem: 'yookassa',
                notification: '',
                discount: 0,
                price: null,

                payItem: {},

                timetable: null,
                error: null,

                phone: null,
                comment: null,
            }
        },
        mounted() {
            let client_id = ''
            if (this.$metrika && this.$metrika.getClientID()) client_id = this.$metrika.getClientID()
            this.phone = CStorage.popItem('ORD_SUB_phone')
            this.comment = CStorage.popItem('ORD_SUB_comment')

            subscriprionApi.fetchSubscription(this.id)
                .then(async response => {
                    this.subscription = response

                    if (this.subscription && this.subscription.stype === 'OnlineTeacher Group' && !this.timetableId) {
                        this.error = "Ошибка! Некорректная ссылка для оплаты группового абоенмента. Оплата невозможна."
                    } else {
                        const recurrent = (this.$route.query.recurrent === true || this.$route.query.recurrent === 'true')
                        const params = {
                            confirmation_type: 'embedded',
                            promocode: this.$route.query.promocode,
                            recurrent: recurrent,
                            price: this.subscription.price,
                            description: this.subscription.subscription,
                            idsubscription: this.subscription.idsubscription,
                            timetable_id: this.timetableId,
                            client_id: client_id,
                            phone: this.phone,
                            comment: this.comment,
                        }

                        axios({method: 'post', url: '/payment', data: params}).then(payresponse => {
                            console.log(payresponse.data)
                            if (payresponse.data.log && payresponse.data.log.length) this.notification = payresponse.data.log.join('<br/>')
                            this.price = payresponse.data.userpayment.price
                            this.discount = this.subscription.price - payresponse.data.userpayment.price

                            if (payresponse.data.userpayment.price <= 0) {
                                this.$router.push('/paymentstatus/free?idsubscription=' + this.subscription.idsubscription)
                            }

                            this.payItem = {
                                user_payment_id: payresponse.data.userpayment.id,
                                confirmation_type: 'embedded',
                                promocode: this.$route.query.promocode,
                                recurrent: recurrent,
                                price: this.price,
                                description: this.subscription.subscription,
                                idsubscription: this.subscription.idsubscription,
                                timetable_id: this.timetableId,
                                client_id: client_id,
                                phone: this.phone,
                                comment: this.comment,
                                paypalClientId: payresponse.data.paypal_client_id,
                            }
                        })
                        .catch(error => {
                          let data = (error && error.response) ? error.response.data : {message: 'payment error'}
                          this.error = this.pretty(data)
                          this.loading = false
                        })
                    }
                })
                .catch(error => {
                    let data = (error && error.response) ? error.response.data : {message: 'fetchSubscription error'}
                    this.error = this.pretty(data)
                    this.loading = false
                })

            if (this.timetableId) {
                timetableApi.fetchTimetable(this.timetableId)
                    .then(async response => {
                        this.timetable = response
                    })
                    .catch(error => {
                        let data = (error && error.response) ? error.response.data : {message: 'timetableApi error'}
                        this.error = this.pretty(data)
                        this.loading = false
                    })
            }

            this.loading = false
        },

        methods: {
            paymentCaptured(data) {
                this.$router.push('/paymentstatus/' + this.payItem.user_payment_id)
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },


        }
    };
</script>
<style src="@/assets/hometeacher/css/main.css">
</style>
